import { createSelector } from 'reselect';
import { Map, List } from 'immutable';

import { denormalizeModelList } from 'reducers/utils/Normalizer';

const selectFundingReport = (state) => state.get('fundingReport');

const makeSelectById = () =>
  createSelector(selectFundingReport, (state) => state.get('byId', Map()));

const makeSelectAll = () => createSelector(selectFundingReport, (state) => state.get('all', Map()));

const makeSelectAllList = () =>
  createSelector(makeSelectById(), makeSelectAll(), (byId, state) =>
    denormalizeModelList(byId, state.get('ids', List())),
  );

const makeSelectAllLoading = () =>
  createSelector(makeSelectAll(), (state) => state.getIn(['network', 'loading']));

const makeSelectAllError = () =>
  createSelector(makeSelectAll(), (state) => state.getIn(['network', 'error']));

export { makeSelectAll, makeSelectAllList, makeSelectAllLoading, makeSelectAllError };
